import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { localize } from 'react-localize-redux';
import renderDatePicker from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';
import * as validator from 'helpers/Validator';
import { serviceRequestOptions } from 'helpers/VerbiageHelper';
import Checkbox from 'helpers/reduxFormMaterialUiNext/Checkbox';
import { hostIsBoardwalk } from 'helpers/CurrentWindowLocation';
import validate from 'components/tenant_application/validate';
import { deepDiver } from 'helpers/utilities';
import { getCurrentLocale } from 'helpers/i18n';

class TicketConsentForm extends Component {
  styles = {
    form: {
      fontFamily: 'sans-serif',
    },
    noPadding: {
      padding: 0,
    },
    field: {
      marginTop: '-20px',
      marginBottom: 0,
    },
    textFieldStyle: {
      width: '100%',
      fontSize: '14px',
    },
    divider: { marginTop: '20px', marginBottom: '20px', borderTop: '2px dashed rgba(0,0,0,0.7)' },
  };

  render() {
    const { handleSubmit, verbiages } = this.props;
    const passage3 = this.props.translate('ticketConsentP3');
    let passage4 = this.props.landlease
      ? this.props.translate('ticketConsentForLotP4')
      : this.props.translate('ticketConsentForUnitP4');

    if (deepDiver(verbiages, `residentPortal.ticketConsentForUnitP4.${getCurrentLocale()}`)) {
      passage4 = deepDiver(
        verbiages,
        `residentPortal.ticketConsentForUnitP4.${getCurrentLocale()}`
      );
    }

    return (
      <form style={this.styles.form} onSubmit={handleSubmit}>
        {this._renderEmailConsentForm()}
        <div className="row">
          <div className="col-xs-12">{passage3}</div>
          <div className="col-xs-12" style={this.styles.noPadding}>
            <FormControlLabel
              control={<Field name="permission_to_enter" component={Checkbox} />}
              label={this.props.translate('iConsent')}
            />
          </div>
          <div className="col-xs-12">
            {passage4}
            <span style={{ fontWeight: 800, textAlign: 'center' }}>
              {this._renderWishToReceiveAllNoticesOfEntry()}
            </span>
          </div>
        </div>
      </form>
    );
  }

  _renderWishToReceiveAllNoticesOfEntry = () => {
    if (this.props.noticeEmailTurnedOn || hostIsBoardwalk()) return;
    const ticketConsentOptions = {
      serviceRequest: this.props.translate('ticketConsetForUnitOrLotP4a'),
      requestForMaintenance: this.props.translate('ticketConsetForUnitOrLotP4aRFM'),
    };

    return serviceRequestOptions(ticketConsentOptions);
  };

  _renderEmailConsentForm = () => {
    if (this.props.noticeEmailTurnedOn || hostIsBoardwalk()) return;

    const ticketConsentForLotP1Options = {
      serviceRequest: this.props.translate('ticketConsentForLotP1'),
      requestForMaintenance: this.props.translate('ticketConsentForLotP1RFM'),
    };

    const ticketConsentForUnitP1Options = {
      serviceRequest: this.props.translate('ticketConsentForUnitP1'),
      requestForMaintenance: this.props.translate('ticketConsentForUnitP1RFM'),
    };

    const passage1 = this.props.landlease
      ? serviceRequestOptions(ticketConsentForLotP1Options)
      : serviceRequestOptions(ticketConsentForUnitP1Options);
    const passage2 = this.props.translate('ticketConsentP2');

    return (
      <div>
        <div className="row">
          <div className="row">
            <div className="col-xs-12">{passage1}</div>
            <div className="col-xs-12" style={this.styles.noPadding}>
              <FormControlLabel
                control={<Field name="entry_notice_email_consent" component={Checkbox} />}
                label={this.props.translate('iAgree')}
              />
            </div>
          </div>
          {this.props.entryNoticeEmailConsent && (
            <div className="row">
              <div className="col-sm-6" style={{ marginBottom: '15px' }}>
                <label
                  style={{
                    width: '100%',
                    textAlign: 'initial',
                    fontSize: '11px',
                    margin: '11px -10px -10px 15px',
                    marginLeft: '15px',
                    position: 'absolute',
                    top: '-6px',
                    left: '15px',
                  }}
                  aria-label={this.props.translate('dateOfToday').props.children}
                >
                  {this.props.translate('dateOfToday')}
                </label>
                <Field
                  name="date_of_today"
                  component={renderDatePicker}
                  type="date"
                  autoOk
                  floatingLabelFixed
                  textFieldStyle={this.styles.textFieldStyle}
                  floatingLabelText={this.props.translate('dateOfToday')}
                  validate={[validator.required, validator.todaysDate]}
                  style={this.styles.field}
                />
              </div>
            </div>
          )}
          <div className="col-xs-12">{passage2}</div>
        </div>
        <hr style={this.styles.divider} />
      </div>
    );
  };
}

export default compose(
  connect((state, ownProps) => {
    const selector = formValueSelector(ownProps.formName);
    return {
      form: ownProps.formName,
      entryNoticeEmailConsent: selector(state, 'entry_notice_email_consent'),
      verbiages: state.userTypes.verbiages,
    };
  }),
  reduxForm({
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    validate,
  })
)(localize()(TicketConsentForm));
